export default {
  dev: 'ws://sunbeam.teamwork.localhost:8840/',
  staging: 'wss://tw-socket.staging.teamwork.com:443/',
  us: 'wss://tw-socket.teamwork.com:8840/',
  eu: 'wss://tw-socket.eu.teamwork.com:8840/',
  gov: 'wss://tw-socket.gov.teamwork.com:8840/',
  au: 'wss://tw-socket.au.teamwork.com:8840/',
};
